import { useCallback } from 'react';

/** Element ids in ex_web ap_web view for hidden agent-entry modal triggers (link_to_remote_modal). */
const AGENT_ENTRY_TRIGGER_IDS = {
  invoice_report: 'js-agent-entry-register-trigger',
  invoice_report_bulk_upload: 'js-agent-entry-bulk-upload-trigger',
} as const;

export enum AgentEntryOpenDetail {
  InvoiceReport = 'invoice_report',
  InvoiceReportBulkUpload = 'invoice_report_bulk_upload',
}

/**
 * Returns a callback that opens the agent-entry (代理申請) modal by clicking the hidden
 * link in the ap_web document. Same pattern as the import button: ap_frontend triggers
 * a click on a visually-hidden link_to_remote_modal rendered by ex_web.
 */
export function useOpenAgentEntryModal(): (
  reportTypeKey: AgentEntryOpenDetail
) => void {
  return useCallback((reportTypeKey: AgentEntryOpenDetail) => {
    const doc =
      typeof window.parent !== 'undefined' && window.parent !== window
        ? window.parent.document
        : document;
    const id = AGENT_ENTRY_TRIGGER_IDS[reportTypeKey];
    const link = doc.getElementById(id);
    if (link && link instanceof HTMLAnchorElement) {
      link.click();
    }
  }, []);
}
